import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import _ from 'lodash'
import { RestrictionIcons } from '../../../assets/assets'
import PropTypes from "prop-types";
import { useTextResources } from '../../../language';
import { RestrictionTypes } from '../constants';

const RestrictionTypesDropDown = ({onChange, ...rest})=>{
    const text = useTextResources()
    const handleChange = (e, {value})=>{
        if (onChange){
            onChange(value)
        }
    }

    return <Dropdown selection clearable options={
        _.map(RestrictionTypes, (key, value)=>{
            return {
                text: text(value),
                value: key,
                key: key,
                image: { src: RestrictionIcons[key-1] }
            }
        })
    }  onChange={handleChange}
    {...rest}
    />
}

RestrictionTypesDropDown.propTypes = {
    onChange: PropTypes.func
}

export default RestrictionTypesDropDown

